import * as Yup from 'yup';
import { substractTime } from '@composite/calendar/utils';
import { Calendar, ShiftInterval } from '@models';

export function useValidationSchema() {
  return Yup.object<Calendar>().shape({
    validFrom: Yup.string().required('Povinné pole'),
    validTo: Yup.string().required('Povinné pole'),
    intervals: Yup.array()
      .test(
        'validate-intervals',
        'Neboli vyplnené všetky údaje intervalov',
        (value) => {
          if (!value) return true;
          return (
            value?.filter(
              (interval: any) =>
                !interval.type ||
                interval.type === '' ||
                !interval.startingHour ||
                interval.startingHour === '' ||
                !interval.endingHour ||
                interval.endingHour === ''
            ).length === 0
          );
        }
      )
      .test(
        'validate-intervals-2',
        'Čas platnosti "Od" je väčší než čas platnosti "Do" v niektorom zo zadaných intervalov.',
        (value) => {
          if (!value) return true;
          if (
            (value as ShiftInterval[]).some(
              (interval) =>
                substractTime(interval.endingHour, interval.startingHour) <= 0
            )
          ) {
            return false;
          }
          return true;
        }
      ),
  });
}
